import { meta } from "../library/dataService";

import { client } from "./nats-client";

function cleanId(id) {
  const idSplit = id.split("-");
  let i = id;
  if (idSplit.length > 1) {
    i = idSplit[1];
  }
  return i;
}

const findTarget = (el): { target: HTMLElement | null; id: string | null; node: any | null } => {
  let target = el?.closest("[data-testid]");
  if (target == null) return { target: null, id: null, node: null };

  let id = target.dataset.testid;
  let node = meta.getNode(cleanId(id));

  return { target, id, node };
};

function publishOverlay(stream, overlayCollection, pageId, sessionId) {
  const time = new Date().toISOString();
  client.putKvJetstream(stream, pageId, "overlay", {
    clientId: client.getId(),
    sessionId: sessionId,
    source: "Overlay",
    collection: JSON.stringify(overlayCollection),
    time,
  });
}

export const syncOverlay = {
  findTarget: findTarget,
  publishOverlay: publishOverlay,
  cleanId: cleanId,
};
